export const loadOgl = (): Promise<typeof import("ogl")> => import("ogl");
